import Vue from 'vue';
import App from './App.vue';
import ElementUI, {
	Message,
	Notification
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './routers/router.js';
import scroll from 'vue-seamless-scroll';
import Axios from 'axios';
import {
	getToken
} from './untils/func';
import {
	selectDicValueByDicKey
} from './api/system/systemCustomConfig';

import custormConfig from './constant/custormConfig';
import systemConstant from './constant/systemConstant';
import vueSeamlessScroll from 'vue-seamless-scroll';
//引入jquery
import jQuery from 'jquery';
Vue.prototype.$ = jQuery;

import Print from 'vue-print-nb';
Vue.use(Print); //注册

// 引入vue-amap
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
	key: 'd6db454cb89784c330fb074a37847bdc',
	plugin: [
		'AMap.Autocomplete',
		'AMap.PlaceSearch',
		'AMap.Scale',
		'AMap.OverView',
		'AMap.ToolBar',
		'AMap.MapType',
		'AMap.PolyEditor',
		'AMap.CircleEditor',
	],
	// 默认高德 sdk 版本为 1.4.4
	v: '1.4.4',
});

// 引入字体图标库
// import '../public/font-common.css'
import '../public/fonts/iconfont.css';

Axios.interceptors.response.use(
	(res) => {
		const code = res.data.statusCode;
		if (code == 2) {
			window.vueInstance.$router.push('/');
			return Promise.reject();
		} else if (code != 1) {
			Notification.error({
				title: res.data.statusMsg,
			});
			return Promise.reject('error');
		} else {
			return res;
		}
	},
	(error) => {
		Message({
			message: error.message,
			type: 'error',
			duration: 5 * 1000,
		});
		return Promise.reject(error);
	}
);

Axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
Axios.defaults.headers['token'] = getToken();
Axios.defaults.baseURL = '/api';
Axios.defaults.timeout = 1000 * 30;
Vue.use(vueSeamlessScroll);
Vue.use(scroll);
Vue.use(VueAMap);

VueAMap.initAMapApiLoader({
	key: '173262164966b35849defe9664a1567a',
	plugin: [
		'AMap.Autocomplete',
		'AMap.PlaceSearch',
		'AMap.Scale',
		'AMap.OverView',
		'AMap.ToolBar',
		'AMap.MapType',
		'AMap.PolyEditor',
		'AMap.CircleEditor',
	],
	// 默认高德 sdk 版本为 1.4.4
	v: '1.4.4',
});

Vue.prototype.Axios = Axios;

import dataV from '@jiaminghi/data-view';
Vue.use(dataV);

Vue.prototype.msgSuccess = function(msg) {
	this.$message({
		showClose: true,
		message: msg,
		type: 'success'
	});
};

Vue.prototype.msgError = function(msg) {
	this.$message({
		showClose: true,
		message: msg,
		type: 'error'
	});
};

Vue.prototype.msgInfo = function(msg) {
	this.$message.info(msg);
};
Vue.config.productionTip = false;
Vue.use(ElementUI);

selectDicValueByDicKey(systemConstant.SYSTEM_TITLE).then((response) => {
	custormConfig.systemTitle = response.data;
});
Vue.prototype.$custormConfig = custormConfig;
window.myTimer = [];
const vueInstance = new Vue({
	el: '#app',
	router,
	jQuery,
	render: (h) => h(App),
	data() {
		return {
			serviceFeeNameElectric: '', //电服务费名称自定义
			serviceFeeNameWater: '',  //电服务费名称自定义
			loginTitle: '预付费云平台', // 登录标题
			loginDescribeShowFlag: true, // 登录标题下的描述文字是否显示
			isLogin: false,
			tabName: '',
			bigScreenVisible: false,

			deviceNameShowFlag: true,
			lesseeCodeLabel: '商户编号',
			lesseeNameLabel: '商户名称',
			waterHistoryTabShow: true,
			homepageShow: true, //首页是否显示
			dataReportInitShow: false, //系统初始化展示数据报表

			// platformUrl: 'ws://192.168.2.103:8081' //本地测试
			// platformUrl: 'wss://yun.yingld.com:8015/websocketApi' //阿里云测试
			// platformUrl: 'wss://saas.yingld.com:443/websocketApi' //阿里云正式丽达
			platformUrl: 'wss://saas.yingld.com:8016/websocketApi', //阿里云正式山东朗进科技股份有限公司
			// platformUrl: 'wss://saas.yingld.com:8015/websocketApi' //阿里云正式宜昌市新中盛汽贸市场有限公司
			// platformUrl: 'wss://saas.yingld.com:8013/websocketApi' //阿里云正式深圳华力奥
		};
	},
});
window.vueInstance = vueInstance;
